import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const LockIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 12 15" },
        React.createElement("path", { d: "M11.5 6H9.75V4C9.75 1.93262 8.06787 0.25 6 0.25C3.93213 0.25 2.25 1.93262 2.25 4V6H0.5C0.22388 6 0 6.22388 0 6.5V13.6337C0 13.8518 0.14429 14.0498 0.35205 14.116C2.60071 14.8328 4.56909 15 6 15C8.30548 15 10.2398 14.5659 11.6604 14.1121C11.867 14.0459 12 13.853 12 13.636V6.5C12 6.22388 11.7761 6 11.5 6ZM6.75 11.5C6.75 11.7761 6.52612 12 6.25 12H5.75C5.47388 12 5.25 11.7761 5.25 11.5V9.5C5.25 9.22388 5.47388 9 5.75 9H6.25C6.52612 9 6.75 9.22388 6.75 9.5V11.5ZM8.25 6H3.75V4C3.75 2.75977 4.75928 1.75 6 1.75C7.24072 1.75 8.25 2.75977 8.25 4V6Z" })));
};

export { LockIcon };
//# sourceMappingURL=LockIcon.esm.js.map
